angular.module('mtic')
.service('LearningEnvironmentService', function () {return {
    givePostItemQuestionnaire: function(moduleId, slug){
        if((moduleId === 1 || moduleId === 11) && slug.indexOf('run_like_math') === -1){
            return true
        }else{
            return false
        }
    }
}});
